const seededRandom = (seed: number): number => {
  const x = Math.sin(seed) * 10000;
  return x - Math.floor(x);
};

export const generateBookRating = (
  bookId: number
): { rating: number; ratingCount: number } => {
  const ratingSeed = bookId * 123;
  const countSeed = bookId * 456;

  const rating = 4.6 + seededRandom(ratingSeed) * 0.3;
  const ratingCount = Math.floor(71 + seededRandom(countSeed) * 132);

  return {
    rating: Math.round(rating * 10) / 10,
    ratingCount,
  };
};
